import { UilBell, UilCheck, UilWrench, UilUser, UilSignout, UilAngleDown, UilKeySkeleton } from '@iconscout/react-unicons';
import { Avatar, Badge, message, Button, Tag } from 'antd';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import { InfoWraper, NavAuth, UserDropDwon } from './auth-info-style';
import Message from './Message';
import Notification from './Notification';
import Search from './Search';
import Settings from './settings';
import { logOut } from '../../../redux/authentication/actionCreator';
import styles from './style.module.css';
import { Dropdown } from '../../dropdown/dropdown';
import Heading from '../../heading/heading';
import { Popover } from '../../popup/popup';
import { getItem, setItem } from '../../../utility/localStorageControl';
import { notificationsDataDelete, notificationsDataRead } from '../../../redux/Notifications/actionCreator';

const AuthInfo = React.memo(() => {
  const dispatch = useDispatch();

  const { NotificationsDeleteRes, NotificationsRes, profileInfo, adminProfileInfo } = useSelector((state) => {
    return {
      profileInfo: state.PersonUpdateRes.data,
      adminProfileInfo: state.AdminUpdateRes.data,
      NotificationsRes: state.NotificationsRes.data,
      NotificationsDeleteRes: state.NotificationsDeleteRes.data,
    }
  })

  const { CheckableTag } = Tag;

  const [state, setState] = useState({
    flag: 'en',
  });
  const [visible, setVisible] = useState(false);
  const [notifications, setNotifications] = useState([]);
  const [filteredNotifications, setfilteredNotifications] = useState([]);
  const [statusChecked, setStatusChecked] = useState(false);
  const [progressChecked, setProgressChecked] = useState(false);

  const navigate = useNavigate();
  const { i18n } = useTranslation();
  const { flag } = state;
  const [profileImage, setProfileImage] = useState(getItem('image'))

  const SignOut = (e) => {
    e.preventDefault();

    dispatch(logOut(() => navigate('/')));
  };
  const username = getItem('username');
  const role = getItem('role')
  const navigationRole = (role === 'EMPLOYEE' || role === 'INTERN') ? 'employee' : 'admin';
  const realname = (username[0]?.toUpperCase() + username.slice(1).toLowerCase());
  const userId = getItem('userId');
  const [designation, setDesignation] = useState(getItem('designation'))

  useEffect(() => {
    if (dispatch) {
      dispatch(notificationsDataRead(parseInt(userId)))
    }
  }, [dispatch])

  useEffect(() => {
    if (NotificationsDeleteRes !== null && NotificationsDeleteRes.Error === false) {
      dispatch(notificationsDataRead(parseInt(userId)))
    }
  }, [NotificationsDeleteRes])

  useEffect(() => {
    if (profileInfo && profileInfo.image) {
      setProfileImage(profileInfo.image)
      setItem('image', profileImage.image)
    }
    if (adminProfileInfo && adminProfileInfo.image) {
      setProfileImage(adminProfileInfo.image)
    }
    if (adminProfileInfo && adminProfileInfo.designation) {
      setDesignation(adminProfileInfo.designation)
      setItem('designation', adminProfileInfo.designation)
    }
  }, [profileInfo, adminProfileInfo])

  useEffect(() => {
    if (NotificationsRes && NotificationsRes.length) {
      const filteredData = NotificationsRes?.map((item, index) => ({
        id: item?.id,
        key: item?.id,
        title: item?.title,
        message: item?.message,
        createdby: item?.createdBy,
        createdon: item?.createdon,
        type: item?.type,
      })).sort((a, b) => new Date(b.createdon) - new Date(a.createdon));
      setNotifications(filteredData);
      setfilteredNotifications(filteredData);
    } else {
      setNotifications([]);
      setfilteredNotifications([])
    }
  }, [NotificationsRes])

  useEffect(() => {
    let tempValues = [...filteredNotifications];
    if (progressChecked === true) {
      tempValues = tempValues.filter(item => item.type === 'PROGRESS')
    }
    if (statusChecked === true) {
      tempValues = tempValues.filter(item => item.type === 'STATUS')
    }
    setNotifications(tempValues)
  }, [progressChecked, statusChecked])

  const userContent = (
    <UserDropDwon>
      <div className="user-dropdwon">
        <figure className="user-dropdwon__info">
          <img src={require('../../../static/img/avatar/chat-auth.png')} alt="" />
          <figcaption>
            <Heading as="h4">{realname}</Heading>
            <h5>{designation !== null ? designation : 'NA'}</h5>
          </figcaption>
        </figure>
        <ul className="user-dropdwon__links">
          <li>
            <Link to={`/${navigationRole}/profile`}>
              <UilUser /> Profile
            </Link>
          </li>
        </ul>
        <Link className="user-dropdwon__bottomAction" onClick={SignOut} to="#">
          <UilSignout /> Sign Out
        </Link>
      </div>
    </UserDropDwon>
  );

  const markAsRead = (id) => {
    const payload = {
      notificationId: [id]
    }
    dispatch(notificationsDataDelete(payload));
  };

  const markAllAsRead = () => {
    const notificationIds = notifications.map(item => item.id);
    const payload = {
      notificationId: notificationIds
    }
    dispatch(notificationsDataDelete(payload));
  }

  const handleStatusChange = (e) => {
    if (progressChecked) {
      setProgressChecked(false);
    }
    setStatusChecked(e);
  }
  const handleProgressChange = (e) => {
    if (statusChecked) {
      setStatusChecked(false)
    }
    setProgressChecked(e);
  }

  const notificationContent = (
    <div className="notification-popup">
      {notifications.length > 0 || filteredNotifications.length > 0 ? (
        <>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <div>
              <CheckableTag key="status" checked={statusChecked} onChange={(e) => handleStatusChange(e)}>
                Status
              </CheckableTag>
              <CheckableTag key="progress" checked={progressChecked} onChange={(e) => handleProgressChange(e)}>
                Progress
              </CheckableTag>
            </div>
            <div>
              {notifications?.length > 0 &&
                <Button
                  onClick={markAllAsRead}
                  className="btn-markComplete"
                  outlined
                  type="text"
                  size="small"
                >Mark all as read</Button>
              }
            </div>
          </div>
          <div>
            {notifications.length > 0 ?
              notifications.map((notif) => (
                <div
                  key={notif.key}
                  className="notification-item mt-10"
                  style={{ display: 'flex', flexDirection: 'column', gap: '8px' }} // Added gap for spacing
                >

                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <Link to={(role === 'EMPLOYEE' || role === 'INTERN') ? `/employee/mytasks` : `/admin/task-manager`}>
                      <span style={{ color: '#073886' }}>{notif.title}</span>
                    </Link>
                    <Button
                      onClick={() => markAsRead(notif.id)}
                      className="btn-markComplete"
                      outlined
                      type="text"
                      size="small"
                    >
                      Mark as read
                    </Button>
                  </div>
                  <div>
                    <span style={{ textAlign: 'justify' }} className="mr-10">{notif.message}</span>
                  </div>
                </div>
              ))
              :
              <div className='text-center mt-30'>
                <img src={require('./dog_text.png')} width={160} />
              </div>
            }
          </div>
        </>
      ) : (
        <div className='text-center mt-30'>
          <img src={require('./dog_text.png')} width={160} />
        </div>
      )}
    </div>

  );

  return (
    <>
      <InfoWraper className={styles['center-content']}>
        <Popover
          content={notificationContent}
          trigger="click"
          visible={visible}
          onVisibleChange={setVisible}
          placement="bottomRight"
        >
          <Badge className='mr-20' count={notifications.length} offset={[0, 0]}>
            <a className='align-center-v'>
              <UilBell
                style={{ cursor: 'pointer', color: 'grey', marginRight: '5px' }}
              />
            </a>
          </Badge>
        </Popover>
        <div className="ninjadash-nav-actions__item ninjadash-nav-actions__author">
          <Popover placement="bottomRight" content={userContent} action="click">
            <Link to="#" className="ninjadash-nav-action-link">
              <div className='cursor-style'>
                <img
                  style={{ height: '32px', width: '32px' }}
                  className='img-border-radius' src={`${process.env.REACT_APP_API_ENDPOINT}/public/profile/${profileImage}`}
                  onError={(e) => {
                    e.target.style.display = "none";
                    e.target.parentNode.appendChild(document.createElement("div")).innerHTML =
                      `<span class="ant-avatar ant-avatar-circle">
                  ${username[0].toUpperCase()}
                  </span>`;
                  }}
                />
              </div>
              <span className="ninjadash-nav-actions__author--name">{realname}</span>
              <UilAngleDown />
            </Link>
          </Popover>
        </div>
      </InfoWraper>
    </>
  );
});

export default AuthInfo;
